import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

const footerLinks = [
    { to: '/', label: 'Forside' },
    { to: '/recipes', label: 'Opskrifter' },
    { to: '/pantry', label: 'Spisekammer' },
    { to: '/blog', label: 'Blog' },
    { to: '/vision', label: 'Vores vision' },
    { to: '/contact', label: 'Kontakt os' },
];

function Footer() {
    return (
        <footer className="footer app-footer">
            <Container fluid="lg" className="app-footer-shell">
                <Row className="app-footer-main g-4">
                    <Col xs={12} lg={5}>
                        <Link to="/" className="app-footer-brand">
                            Budgetvenlig <span>beta</span>
                        </Link>
                        <p className="app-footer-copy">
                            Madplaner og opskrifter, der tager udgangspunkt i ugens tilbud, få ingredienser og mindre madspild.
                        </p>
                        <div className="app-footer-badges" aria-label="Budgetvenligs fokusområder">
                            <span>Tilbud først</span>
                            <span>Smartere indkøb</span>
                            <span>Mindre spild</span>
                        </div>
                    </Col>
                    <Col xs={12} sm={6} lg={3}>
                        <h2 className="app-footer-heading">Gå til</h2>
                        <nav className="app-footer-links" aria-label="Footer navigation">
                            {footerLinks.map((link) => (
                                <Link key={link.to} to={link.to}>
                                    {link.label}
                                </Link>
                            ))}
                        </nav>
                    </Col>
                    <Col xs={12} sm={6} lg={4}>
                        <h2 className="app-footer-heading">Bygget til hverdagen</h2>
                        <p className="app-footer-copy">
                            Vælg dine butikker, find retter med aktuelle tilbud, og brug fleksible erstatninger når priserne skifter.
                        </p>
                        <a href="mailto:budgetvenlig@gmail.com" className="app-footer-contact">
                            budgetvenlig@gmail.com
                        </a>
                    </Col>
                </Row>
                <Row className="app-footer-bottom align-items-center">
                    <Col xs={12} md={7}>
                        <p>Budgetvenlig gør billigere hverdagsmad nemmere at planlægge.</p>
                    </Col>
                    <Col xs={12} md={5} className="text-md-end">
                        <p>Dansk madplanlægning · beta</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
